























import _ from "lodash";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class QQuestionAnswer extends Vue {
  @Prop({ default: "h4" }) readonly tag!: string;
  @Prop({ type: Object, default: () => ({}) }) readonly question!: any;

  localQuestion: any = null;

  answerText = "";
  showOtherOptions = false;
  otherOptions: string[] = [];
  otherOptionPosition: string | null = null;

  beforeMount() {
    this.localQuestion = this.$store.getters["Questionnaire/mapQuestion"](
      this.question
    );

    this.answerText = this.localQuestion.value.answer;
    if (!this.answerText) {
      return;
    }

    // init other options
    this.otherOptions = Array.isArray(this.localQuestion.options)
      ? [...this.localQuestion.options]
      : [this.localQuestion.options];

    switch (this.localQuestion.type) {
      case "radiobutton":
      case "checkbox":
      case "body_parts":
      case "country":
      case "state":
      case "dropdown_single":
      case "dropdown_multiple": {
        // split the raw answer value by ',', multiple answer example: "a,b,c"
        const selectedOptions = this.answerText.split(",");
        if (selectedOptions.length > 0) {
          // check show_other_options_in_report and show_other_options_position in selected options
          _.each(this.localQuestion.options, (option: any) => {
            if (selectedOptions.includes(option.value)) {
              // the current option is selected
              this.showOtherOptions =
                option.show_other_options_in_report || this.showOtherOptions;
              this.otherOptionPosition =
                option.show_other_options_position ?? this.otherOptionPosition;
              // if the show_other_options_in_report is true, get other options based on the position value
              if (this.showOtherOptions) {
                this.otherOptions = this.getOtherOptions(option);
              }
            }
          });

          // selectedOptions is an array, each item in the array is a quesiton option key.
          // we need to revert the option key by the option display name.
          // due to the question has been remap to align the library setup, so the "display_name" has been remapped to "title"
          this.answerText = selectedOptions
            .map(optionKey => {
              // `optionKey` is answered option key
              // `opt['value']` is one of answer option key defined in question
              const answerOption = this.localQuestion.options.find(
                opt => opt["value"] === optionKey
              );
              // if answerOption is found, return answer option "display_name" a.k.a. `answeroption.title`
              // if answerOption is NOT found, return it original answer option key wrapped with "[]"
              return answerOption ? answerOption.title : `[${optionKey}]`;
            })
            .join(", ");
        } else {
          return null;
        }
        break;
      }
      case "datepicker":
      case "datetimepicker": {
        if (this.localQuestion.options.range) {
          const [from, to] = this.answerText.split(",");
          const fromDate = new Date(from);
          const toDate = new Date(to);
          if (this.localQuestion.options.date_format === "mm/yy") {
            this.answerText = `${this.getMonthYearDate(
              fromDate
            )} - ${this.getMonthYearDate(toDate)}`;
          } else {
            this.answerText = `${this.getFullDate(
              fromDate
            )} - ${this.getFullDate(toDate)}`;
          }
        } else {
          const date = new Date(this.answerText);
          if (this.localQuestion.options.date_format === "mm/yy") {
            this.answerText = this.getMonthYearDate(date);
          } else {
            this.answerText = this.getFullDate(date);
          }

          if (this.localQuestion.type === "datetimepicker") {
            this.answerText = `${date
              .getHours()
              .toString()
              .padStart(2, "0")}:${date
              .getMinutes()
              .toString()
              .padStart(2, "0")}`;
          }
        }
        break;
      }
      default:
        break;
    }
  }

  getOtherOptions(currentOption: any) {
    return this.otherOptions.filter(
      (option: any) => option.value !== currentOption.value
    );
  }

  getFullDate(date) {
    return `${date
      .getDate()
      .toString()
      .padStart(2, "0")}/${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}/${date.getFullYear()}`;
  }

  getMonthYearDate(date) {
    return `${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}/${date.getFullYear()}`;
  }

  joinAnswerOptionText(answerOptions) {
    return answerOptions.map((option: any) => option.title).join(", ");
  }
}
